import { setCookie } from './set-cookie.js';

function cookieMessage() {
  $('.js-cookie-continue').on('click', () => {
    $('body').removeClass('cookie-shown');
    setCookie();
  });
}
export default { cookieMessage };



// WEBPACK FOOTER //
// ./src/js/custom/cookie-message.js